import { render, staticRenderFns } from "./ItemUpdater.vue?vue&type=template&id=57707fdc&"
import script from "./ItemUpdater.vue?vue&type=script&lang=ts&"
export * from "./ItemUpdater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports